/* eslint-disable */

import React from 'react';
import CopyableSnippet from '../../components/utils/CopyableSnippet';
import LinkableTitle from '../../components/linkableTitle';

const divStyle  = {
  backgroundColor: '#272f5e',
  padding: '10px 15px',
};

const Typography = () => (
  <React.Fragment>
    <div className="page-header">
      <p>Core</p>
      <h1>Typography</h1>
    </div>
    <div className="page-content">
      <div className="component-example__sub-example">
        <blockquote>
          These classes are provided by the global stylesheet <br />(base.css from service-site-assets)
        </blockquote>
        <blockquote>
          Standard body text is 16px, in Effra font
        </blockquote>
        <LinkableTitle name="font-sizes" title="Font sizes" />
        <div className="margin-top-bottom-ml l-flex-vcenter">
          <CopyableSnippet code="fs-8" />
          <h3 className="mb-0 ml-1 fs-8">.fs-8 (56px)</h3>
        </div>
        <div className="margin-top-bottom-ml l-flex-vcenter">
          <CopyableSnippet code="fs-7" />
          <h3 className="mb-0 ml-1 fs-7">.fs-7 (40px)</h3>
        </div>
        <div className="margin-top-bottom-ml l-flex-vcenter">
          <CopyableSnippet code="fs-6" />
          <h3 className="mb-0 ml-1 fs-6">.fs-6 (32px)</h3>
        </div>
        <div className="margin-top-bottom-ml l-flex-vcenter">
          <CopyableSnippet code="fs-5" />
          <h3 className="mb-0 ml-1 fs-5">.fs-5 (24px)</h3>
        </div>
        <div className="margin-top-bottom-ml l-flex-vcenter">
          <CopyableSnippet code="fs-4" />
          <h3 className="mb-0 ml-1 fs-4">.fs-4 (22px)</h3>
        </div>
        <div className="margin-top-bottom-ml l-flex-vcenter">
          <CopyableSnippet code="fs-3" />
          <h3 className="mb-0 ml-1 fs-3">.fs-3 (18px)</h3>
        </div>
        <div className="margin-top-bottom-ml l-flex-vcenter">
          <CopyableSnippet code="fs-2" />
          <h3 className="mb-0 ml-1 fs-2">.fs-2 (16px)</h3>
        </div>
        <div className="margin-top-bottom-ml l-flex-vcenter">
          <CopyableSnippet code="fs-1" />
          <h3 className="mb-0 ml-1 fs-1">.fs-1 (14px)</h3>
        </div>
        <div className="margin-top-bottom-ml l-flex-vcenter">
          <CopyableSnippet code="fs-0" />
          <h3 className="mb-0 ml-1 fs-0">.fs-0 (12px)</h3>
        </div>
      </div>

      <div className="component-example__sub-example">
        <LinkableTitle name="font-weights" title="Font weights" />
        <div className="margin-top-bottom-ml l-flex-vcenter">
          <CopyableSnippet code="fw-regular" />
          <h3 className="mb-0 ml-1 fw-regular">.fw-regular (regular 400)</h3>
        </div>
        <div className="margin-top-bottom-ml l-flex-vcenter">
          <CopyableSnippet code="fw-medium" />
          <h3 className="mb-0 ml-1 fw-medium">.fw-medium (medium 500)</h3>
        </div>
      </div>

      <div className="component-example__sub-example">
        <LinkableTitle name="font-styles" title="Font style" />
        <div className="margin-top-bottom-ml l-flex-vcenter">
          <CopyableSnippet code="fs-italic" />
          <p className="mb-0 ml-1 fs-italic">.fs-italic</p>
        </div>
      </div>

      <div className="component-example__sub-example">
        <LinkableTitle name="links" title="Links" />
        <div className="margin-top-bottom-ml l-flex-vcenter">
          <CopyableSnippet code="link" />
          <a href="#" className="ml-1 link">.link</a>
        </div>
        <div className="margin-top-bottom-ml l-flex-vcenter">
          <CopyableSnippet code="link link--underline" />
          <a href="#" className="ml-1 link link--underline">.link.link--underline</a>
        </div>
        <div className="margin-top-bottom-ml l-flex-vcenter">
          <CopyableSnippet code="link link--monotone" />
          <a href="#" className="ml-1 link link--monotone">.link.link--monotone</a>
        </div>
        <div className="margin-top-bottom-ml l-flex-vcenter">
          <CopyableSnippet code="link link--inverse" />
          <span className="ml-1" style={divStyle}>
            <a href="#" className="link link--inverse">.link.link--inverse</a>
          </span>
        </div>
        <p>Utility classes can be combined:</p>
        <div className="margin-top-bottom-ml l-flex-vcenter">
          <CopyableSnippet code="link link--underline link--monotone" />
          <a href="#" className="ml-1 link link--underline link--monotone">.link.link--underline.link--monotone</a>
        </div>
        <div className="margin-top-bottom-ml l-flex-vcenter">
          <CopyableSnippet code="link link--underline link--inverse" />
          <span className="ml-1" style={divStyle}>
            <a href="#" className="link link--underline link--inverse">.link.link--underline.link--inverse</a>
          </span>
        </div>
      </div>

      <div className="component-example__sub-example">
        <LinkableTitle name="text-positioning" title="Text positioning" />
        <div className="text-left">
          <CopyableSnippet code="text-left" />
        </div>
        <div className="text-center">
          <CopyableSnippet code="text-center" />
        </div>
        <div className="text-right">
          <CopyableSnippet code="text-right" />
        </div>
      </div>

      <div className="component-example__sub-example">
        <LinkableTitle name="responsive-text-positioning" title="Responsive text positioning" />
        <div className="text-left-sm">
          <CopyableSnippet code="text-left-sm" />
        </div>
        <div className="text-center-md">
          <CopyableSnippet code="text-center-md" />
        </div>
        <div className="text-right-lg">
          <CopyableSnippet code="text-right-lg" />
        </div>
      </div>
    </div>
  </React.Fragment>
);

export default Typography;
